// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".picker.picker--value select{-webkit-appearance:none;appearance:none;background-color:initial;background-image:url(//cdn.shopify.com/s/files/1/1683/2271/t/14/assets/ico-select.svg?v=1474307%E2%80%A6);background-position:right .9375rem center;background-repeat:no-repeat;border:1px solid #d9d9d9;border-radius:0;cursor:pointer;height:2.5rem;padding-left:.9375rem;padding-right:3.75rem;text-indent:.01px;width:100%}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
